const awsconfig = {
  aws_project_region: import.meta.env.VITE_AWS_PROJECT_REGION || "eu-central-1",
  aws_cognito_region: import.meta.env.VITE_AWS_COGNITO_REGION || "eu-central-1",
  aws_user_pools_id: import.meta.env.VITE_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: import.meta.env
    .VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain:
      import.meta.env.VITE_AWS_COGNITO_DOMAIN ||
      "sandbox-turnus-ai.auth.eu-central-1.amazoncognito.com",
    scope: ["aws.cognito.signin.user.admin", "email", "profile", "openid"],
    redirectSignIn:
      import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_SIGN_IN ||
      "http://localhost:3000",
    redirectSignOut:
      import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_SIGN_OUT ||
      "http://localhost:3000",
    responseType: "token", // or 'token' depending on your use case
  },
  aws_cognito_username_attributes: [],
  aws_cognito_signup_attributes: ["name"],
}

export default awsconfig
